import { alpha, type Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";

export const AWAITING_INPUT_BASE = "#FFD600";
export const AWAITING_INPUT_ON_BASE = "rgba(0, 0, 0, 0.87)";

export const getAwaitingInputAccentColor = (theme: Theme): string =>
  theme.palette.mode === "dark" ? "#FFE082" : "#8D5B00";

export const getAwaitingInputSurfaceStyles = (theme: Theme) => ({
  backgroundColor: alpha(AWAITING_INPUT_BASE, theme.palette.mode === "dark" ? 0.16 : 0.12),
  borderColor: alpha(AWAITING_INPUT_BASE, theme.palette.mode === "dark" ? 0.5 : 0.32),
  accentColor: getAwaitingInputAccentColor(theme),
});

export const getAwaitingInputChipSx = (): SystemStyleObject<Theme> => ({
  bgcolor: AWAITING_INPUT_BASE,
  color: AWAITING_INPUT_ON_BASE,
  boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.08) inset",
  "& .MuiChip-icon": { color: AWAITING_INPUT_ON_BASE },
});

export const getAwaitingInputBadgeSlotSx = (): SystemStyleObject<Theme> => ({
  bgcolor: AWAITING_INPUT_BASE,
  color: AWAITING_INPUT_ON_BASE,
  boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.08) inset",
});

export const getAwaitingInputOutlinedButtonSx = (
  theme: Theme,
): SystemStyleObject<Theme> => {
  const { accentColor } = getAwaitingInputSurfaceStyles(theme);

  return {
    color: accentColor,
    borderColor: alpha(AWAITING_INPUT_BASE, theme.palette.mode === "dark" ? 0.45 : 0.38),
    backgroundColor: alpha(AWAITING_INPUT_BASE, theme.palette.mode === "dark" ? 0.12 : 0.08),
    "&:hover": {
      borderColor: alpha(AWAITING_INPUT_BASE, theme.palette.mode === "dark" ? 0.65 : 0.5),
      backgroundColor: alpha(AWAITING_INPUT_BASE, theme.palette.mode === "dark" ? 0.18 : 0.14),
    },
  };
};
